
import {
  ref, computed, defineComponent, onMounted, Ref,
} from '@vue/composition-api';
import Vue from 'vue';
import {
  Carousel, Slide, FCButton, FiveStars,
} from '@fc/angie-ui';
import FCImage from '~/components/FCImage.vue';
import SplitView from '~/components/SplitView.vue';
import SizeSelectors from '@/shared/components/SizeSelectors.vue';
import Video from '~/components/storyblok/Video/Video.vue';
import storeMutations from '~/store/constants/storeMutations';
import ProductsUpsell from '~/components/products/Products_Upsell.vue';
import ProductsIncludedItems from '~/components/products/Products_IncludedItems.vue';
import { IVideoExpectedAttrs } from '~/components/storyblok/Video/types';
import SmoothScroll from 'vue2-smooth-scroll';
import gqFightcampTrackers from '~/components/products/content/gq_fightcamp_trackers';

export interface ISelectedItem {
  itemId: string;
  product: {
    category?: string;
  }
}

export interface IPictureResponsive {
  _uid: string;
  Image: {
    filename: string;
    alt: string;
  }
}

const MEDIA_GRID = [
  {
    _uid: '029ccbe2-4104-4398-be04-4ca09fd5b1e9',
    codeId: '',
    component: 'Video',
    isOverlay: false,
    playsAudio: false,
    hasControls: false,
    hasPlayIcon: false,
    mp4VideoUrl: 'https://cdn-b.joinfightcamp.com/videos/fc-package-products-connect-small.mp4',
    webmVideoUrl: '',
    firstFrameImage: {
      id: null,
      alt: 'hand putting tracker in quickwrap',
      name: '',
      focus: null,
      title: null,
      filename: 'https://a.storyblok.com/f/152150/1280x960/5b37a1b645/trackers-atf-first-frame-001.png',
      copyright: null,
      fieldtype: 'asset',
    },
    mp4MobileVideoUrl: '',
    webmMobileVideoUrl: '',
    mobileVideoPlayback: 'auto',
    tabletUpVideoPlayback: 'auto',
    _editable: '<!--#storyblok#{"name": "Video", "space": "152150", "uid": "029ccbe2-4104-4398-be04-4ca09fd5b1e9", "id": "272363633"}-->',
  },
  {
    _uid: 'c02d5a5b-5910-4c21-acd8-ae505cdc1905',
    Image: {
      id: 8356188,
      alt: '',
      name: '',
      focus: '',
      title: '',
      filename: 'https://a.storyblok.com/f/152150/964x883/151cdb7a76/fc-trackers-product-atf-wraps-001.png',
      copyright: '',
      fieldtype: 'asset',
      is_external_url: false,
    },
    codeId: '',
    component: 'PictureResponsive',
    imageType: '',
    _editable: '<!--#storyblok#{"name": "PictureResponsive", "space": "152150", "uid": "c02d5a5b-5910-4c21-acd8-ae505cdc1905", "id": "272363633"}-->',
  },
  {
    _uid: 'bd40370e-2cfa-4af7-b7b1-dd659762a1ad',
    Image: {
      id: 6615565,
      alt: 'Man with FightCamp quick wraps and trackers',
      name: '',
      focus: '',
      title: '',
      source: '',
      filename: 'https://a.storyblok.com/f/152150/2701x1801/9e36374629/fc-lifestyle-trackers-product-card-001.jpg',
      copyright: '',
      fieldtype: 'asset',
      meta_data: {},
      is_private: '',
      is_external_url: false,
    },
    codeId: '',
    component: 'PictureResponsive',
    imageType: '',
    _editable: '<!--#storyblok#{"name": "PictureResponsive", "space": "152150", "uid": "bd40370e-2cfa-4af7-b7b1-dd659762a1ad", "id": "272363633"}-->',
  },
  {
    _uid: 'b475d972-bf0f-4ee8-9887-83ecae3f72d3',
    Image: {
      id: 8113166,
      alt: 'Person shadow boxing with FightCamp quick wraps while in living room with FightCamp workout on TV',
      name: '',
      focus: '',
      title: '',
      filename: 'https://a.storyblok.com/f/152150/1962x1308/5aebbf042f/fc-trackers-product-atf-woman-shadowboxing-001.png',
      copyright: '',
      fieldtype: 'asset',
      is_external_url: false,
    },
    codeId: '',
    component: 'PictureResponsive',
    imageType: '',
    _editable: '<!--#storyblok#{"name": "PictureResponsive", "space": "152150", "uid": "b475d972-bf0f-4ee8-9887-83ecae3f72d3", "id": "272363633"}-->',
  },
  {
    _uid: '99c8ac06-02fe-4435-b73a-d01a79b50997',
    Image: {
      id: 8113077,
      alt: 'Person shadow boxing with FightCamp quick wraps',
      name: '',
      focus: '',
      title: '',
      filename: 'https://a.storyblok.com/f/152150/957x891/74f1fe2e65/fc-trackers-product-atf-man-shadowboxing-001.png',
      copyright: '',
      fieldtype: 'asset',
      is_external_url: false,
    },
    codeId: '',
    component: 'PictureResponsive',
    imageType: '',
    _editable: '<!--#storyblok#{"name": "PictureResponsive", "space": "152150", "uid": "99c8ac06-02fe-4435-b73a-d01a79b50997", "id": "272363633"}-->',
  },
  {
    _uid: 'ef6a3ac3-0862-4925-bd6e-8b74dfe0bf68',
    Image: {
      id: 13700762,
      alt: 'Man doing situp while watching FightCamp workout on tv',
      name: '',
      focus: '',
      title: '',
      source: '',
      filename: 'https://a.storyblok.com/f/152150/965x884/23300e2cc1/fc-guy-situp.jpg',
      copyright: '',
      fieldtype: 'asset',
      meta_data: {},
      is_private: '',
      is_external_url: false,
    },
    codeId: '',
    component: 'PictureResponsive',
    imageType: '',
    _editable: '<!--#storyblok#{"name": "PictureResponsive", "space": "152150", "uid": "ef6a3ac3-0862-4925-bd6e-8b74dfe0bf68", "id": "272363633"}-->',
  },
];
const prod = {
  title: gqFightcampTrackers?.title || '',
  text: gqFightcampTrackers?.text || '',
  description: gqFightcampTrackers?.description || '',
  price: gqFightcampTrackers?.product.price || 0,
  oldPrice: gqFightcampTrackers?.product.oldPrice || 0,
  financing: {
    price: gqFightcampTrackers?.product.monthly || 0,
    months: gqFightcampTrackers?.product.months || 0,
  },
  includes: gqFightcampTrackers?.includes || [],
  upsell: gqFightcampTrackers?.upsell || [],
  id: gqFightcampTrackers?.id || '',
  selects: gqFightcampTrackers?.selects || [],
  variants: gqFightcampTrackers?.variants || [],
  bonusOptions: gqFightcampTrackers?.bonusOptions || [],
};

Vue.use(SmoothScroll, {
  duration: 500,
  updateHistory: true,
});

export default defineComponent({
  name: 'GQAboveTheFold',
  components: {
    SplitView,
    FCImage,
    Video,
    FiveStars,
    ProductsIncludedItems,
    SizeSelectors,
    ProductsUpsell,
    FCButton,
    Carousel,
    Slide,
  },
  setup() {
    const {
      $store,
      $smoothScroll,
    // @ts-ignore
    } = useNuxtApp();

    const mediaGrid = MEDIA_GRID;
    function isImage(media: IVideoExpectedAttrs | IPictureResponsive): media is IPictureResponsive {
      return (media as IPictureResponsive).Image !== undefined;
    }

    function getImageSrc(media: IPictureResponsive | IVideoExpectedAttrs) {
      if (isImage(media)) {
        return media.Image.filename;
      }
      return '';
    }

    function getImageAlt(media: IPictureResponsive | IVideoExpectedAttrs) {
      if (isImage(media)) {
        return media.Image.alt;
      }
      return '';
    }

    function scrollToReviews() {
      $smoothScroll({
        scrollTo: document.getElementById('customerReviews'),
        offset: -100,
        updateHistory: false,
      });
    }

    const selectedSize = ref();
    const updateSizeValue = (value: 's' | 'l') => {
      selectedSize.value = value;
    };
    const total = ref(0);
    const formattedTotal = computed(() => {
      const value = total.value / 100;
      return value ? value.toFixed(2) : '';
    });
    const selectedItems: Ref<ISelectedItem[]> = ref([]);
    const loading = ref(false);
    function findVariant() {
      return prod.variants?.find((v) => {
        // eslint-disable-next-line guard-for-in
        for (const key in v.keys) {
          const selected = selectedSize.value;
          if (selected !== v.keys[key]) {
            return false;
          }
        }
        return true;
      });
    }

    function handleTotal($event: number) {
      total.value = $event;
      $store.commit(storeMutations.SET_PACKAGE_PAGE_TOTAL, $event);
    }

    onMounted(() => {
      $store.commit(storeMutations.SET_PACKAGE_PAGE_TOTAL, prod?.price);
      total.value = prod?.price || 0;
    });

    async function addToCart() {
      loading.value = true;
      const variant = findVariant();

      // clear items to handle if shopify items are in cart
      await $store.dispatch('clearCart');

      await $store.dispatch('insertItemToCart', {
        id: variant?.sku,
        type: 'equip',
        disableDrawer: true,
      });

      selectedItems.value.forEach(async (item) => {
        await $store.dispatch('insertItemToCart', {
          id: item.itemId,
          type: item.product.category === 'warranty' ? 'warranty' : 'equip',
        });
      });

      $store.commit('SET_MEMBERSHIP_TYPE', {
        key: 'GQ_FightCamp_1_Month',
        name: 'Monthly',
        type: 'GQfightcampplan',
      });

      $store.commit('closeDrawer');
      window.$nuxt.$router.push('/shop/gq/checkout');
      loading.value = false;
    }

    return {
      mediaGrid,
      isImage,
      getImageSrc,
      getImageAlt,
      prod,
      scrollToReviews,
      updateSizeValue,
      handleTotal,
      addToCart,
      formattedTotal,
      loading,
      selectedItems,
    };
  },
});
